export default {
    getList: {
        getNoticeRuleList: async function (params) {
            let option = {
                url: '/api/v1/user/notifications',
                type: 'get',
                params: params,
                mock: {
                    state: false,
                    data: this.$mock.userNoticeRule.getList.default,
                }
            }
            return await this.$api.handleRequest.call(this, option);
        },
        getSite: async function (params) {
            let option = {
                url: '/api/v1/user/site' + '/' + params.site_id,
                type: 'get',
                params: params,
                mock: {
                    state: false,
                    data: this.$mock.userNoticeRule.getList.default,
                }
            }
            return await this.$api.handleRequest.call(this, option);
        }
    }
}